/**
 * Vacancy Filter functionality.
 *
 * @module foundation/Tags
 */
import ImportsFilter from './ImportsFilter.js';

/**
 * Vacancy Filter component functionality.
 *
 * @extends module:foundation/Tags.ImportsFilter
 * @memberof module:foundation/Tags
 * @version 1.0.0
 * @author Rocco Janse <rocco.janse@valtech.nl>
 */
class VacancyFilter extends ImportsFilter {
    /**
     * Upgrades DOM element, gathers querystring data and initializes collapses (for mobile) and filters.
     * @param {DOMElement} element DOM element to upgrade.
     * @param {object} [repository] Repository to get data from.
     */
    constructor(element, repository = null) {
        super(element, repository);

        // get keyword input
        this.$keywordInput = $('.js-vacancies-keyword').first();
        this.$keywordInput.on({
            'blur.vacancyfilter': this.onKeyword.bind(this),
            'keyup.vacancyfilter': this.onKeywordKeyUp.bind(this),
        });
    }

    init() {
        super.init();
    }

    /**
     * Enables filter state.
     * @param {object} data Repository data.
     */
    setEnabledFilters(data) {
        if (typeof data.Filters !== 'undefined') {
            let filtersToEnable = data.Filters;
            for (let filter of filtersToEnable) {
                const $input = this.$element.find(`input[id="${filter.Category}-${filter.Id}"]`);
                if ($input.length > 0) {
                    if (filter.Count > 0) {
                        $input.prop('disabled', false);
                        $input.parent('div').find('.badge').text(filter.Count);
                    } else {
                        $input.parent('div').find('.badge').text(filter.Count);
                    }
                }
            }
        }
    }

    /**
     * Creates selectedTags for the repository.
     */
    createSelectedTags(keyword = null) {
        this.selectedTags = {};

        if (keyword) {
            this.selectedTags['keyword'] = keyword;
        } else {
            if (this.$keywordInput.val()) {
                this.selectedTags['keyword'] = this.$keywordInput.val();
            }
        }

        for (let filter of this.$element.find('input[type=checkbox]:checked, input[type=radio]:checked')) {
            if (typeof this.selectedTags[$(filter).attr('name')] === 'undefined') {
                // create selectedTags as string
                this.selectedTags[$(filter).attr('name')] = $(filter).val();
            } else if (typeof this.selectedTags[$(filter).attr('name')] === 'string') {
                // if selectedTags is a string, convert to array and add value
                const current = this.selectedTags[$(filter).attr('name')];
                this.selectedTags[$(filter).attr('name')] = [current, $(filter).val()];
            } else {
                // selectedTags is already an array, add value
                this.selectedTags[$(filter).attr('name')].push($(filter).val());
            }
        }
    }

    /**
     * Set checked tags.
     * @param {Object} data Repository data.
     */
    setCheckedTags(data) {
        if (typeof data.SelectedTags !== 'undefined') {
            for (const filter in data.SelectedTags) {
                // fill keyword input
                if (filter === 'keyword') {
                    this.$keywordInput.val(data.SelectedTags[filter]);
                }

                if ($.isArray(data.SelectedTags[filter])) {
                    data.SelectedTags[filter].forEach((value) => {
                        const $input = this.$element.find(`input[name="${filter}"][value="${value}"]`);
                        if ($input.length > 0) {
                            $input.attr('checked', 'checked');
                            // open parent collapse
                            $input.parents('.collapse').addClass('show');
                            // activate trigger
                            $input.parents('li.filter').find('.collapse-toggle').addClass('active');
                        }
                    });
                } else {
                    const $input = this.$element.find(`input[name="${filter}"][value="${data.SelectedTags[filter]}"]`);

                    if ($input.length > 0) {
                        $input.attr('checked', 'checked');
                        // open parent collapse
                        $input.parents('.collapse').addClass('show');
                        // activate trigger
                        $input.parents('li.filter').find('.collapse-toggle').addClass('active');
                    }
                }
            }
        }
    }

    /**
     * "Submit" keyword input when enter is pressed.
     * @param {Event} e jQueryEvent.
     */
    onKeywordKeyUp(e) {
        if (e.keyCode === 13) {
            this.onKeyword(e);
        }
    }

    /**
     * Add keyword to Repository.
     * @param {Event} e jQuery Event.
     */
    onKeyword(e) {
        const $input = $(e.currentTarget);
        this.createSelectedTags($input.val());

        // update repository
        this.updateRepository({
            Tags: this.selectedTags,
            SelectedTags: this.selectedTags,
        });
    }
}

export default VacancyFilter;
